var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWoman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#303030",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16/woman"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.43927 3.7933C8.03994 3.71381 7.62919 3.74462 7.24999 3.87868C6.85947 4.01675 6.43096 3.81209 6.29289 3.42157C6.15482 3.03104 6.35948 2.60253 6.75001 2.46447C7.38192 2.24106 8.06651 2.18967 8.73212 2.32217C9.62433 2.49977 10.4216 2.99565 10.9753 3.71743C11.529 4.43921 11.8015 5.33768 11.742 6.24544C11.6824 7.15321 11.2949 8.00838 10.6516 8.65165C10.1291 9.17417 9.46678 9.52794 8.75 9.67424V10.75H9.5C9.91422 10.75 10.25 11.0858 10.25 11.5C10.25 11.9142 9.91422 12.25 9.5 12.25H8.75V13C8.75 13.4142 8.41422 13.75 8 13.75C7.58579 13.75 7.25 13.4142 7.25 13V12.25H6.5C6.08579 12.25 5.75 11.9142 5.75 11.5C5.75 11.0858 6.08579 10.75 6.5 10.75H7.25V9.67424C6.69693 9.56133 6.17212 9.32412 5.71743 8.97529C4.99565 8.42156 4.49977 7.62433 4.32217 6.73212C4.18967 6.06651 4.24106 5.38192 4.46446 4.75001C4.60253 4.35948 5.03104 4.15482 5.42157 4.29289C5.81209 4.43096 6.01675 4.85947 5.87868 5.24999C5.74462 5.62919 5.71381 6.03994 5.7933 6.43927C5.89987 6.9746 6.19739 7.45293 6.63046 7.78517C7.06353 8.11741 7.60261 8.2809 8.14727 8.24517C8.69193 8.20945 9.20503 7.97695 9.59099 7.59099C9.97695 7.20503 10.2094 6.69193 10.2452 6.14727C10.2809 5.60261 10.1174 5.06353 9.78517 4.63046C9.45294 4.19739 8.9746 3.89987 8.43927 3.7933Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWoman);
export default __webpack_public_path__ + "static/media/woman.1cf60f4e.svg";
export { ForwardRef as ReactComponent };